module.exports = __webpack_public_path__ + "static/media/microsoft365Logo.ac837b48.png";